export class LocationModel {
  constructor(latitude, longitude) {
    this.latitude = latitude;
    this.longitude = longitude;
    this.lat = latitude;
    this.lng = longitude;
  }
}
